import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../common/Header.js'
import InnerBanner from '../common/InnerBanner.js'
import Footer from '../common/Footer.js'

export const About = () => {
  return (
    <>
      <Header />

      <InnerBanner title="About Us" />

      {/* ABOUT DLMP21 */}
      <section className="w3l-covers-9-main">
        <div className="covers-9 sec-padding">
          <div className="wrapper">

            <div className="d-grid cover-top-center-9">

              <div className="w3ls_cover_txt-9">
                <h3 className="title-cover-9">
                  Welcome To DLMP21
                </h3>

                <p className="para-cover-9">
                  DLMP21 is operated by Dreams Linkage Marketing Pro 21
                  (I)(OPC) Pvt. Ltd., established in 2017 with a vision of
                  connecting everyday customers with local businesses through
                  online and offline channels.
                </p>

                <p className="para-cover-9">
                  Our platform is designed to help customers discover
                  participating shops, explore local offers and make eligible
                  purchases while participating in the DLMP21 customer reward
                  network.
                </p>

                <p className="para-cover-9">
                  We aim to make the local shopping experience more convenient
                  while helping participating businesses connect with customers
                  through the DLMP21 platform.
                </p>

                <Link
                  to="/how-its-works"
                  className="btn button-eff"
                >
                  How DLMP21 Works
                </Link>
              </div>

              <div className="right-text">
                <img
                  src="assets/images/about.jpg"
                  alt="About DLMP21"
                  className="img-responsive img-fluid"
                />
              </div>

            </div>

          </div>
        </div>
      </section>


      {/* HOW IT WORKS */}
      <section className="w3l-features-4">
        <div className="features4-block">
          <div className="wrapper">

            <h3 className="title-main">
              How DLMP21 Works
            </h3>

            <div className="features4-grids text-left">

              {/* STEP 1 */}
              <div className="features4-grid">

                <div className="feature-images">
                  <span
                    className="fa fa-user-plus"
                    aria-hidden="true"
                  ></span>
                </div>

                <h5>
                  <Link to="/register">
                    Create Your Account
                  </Link>
                </h5>

                <p>
                  Register with DLMP21 and create your customer account.
                  Your account provides access to the features and services
                  available through the platform.
                </p>

              </div>


              {/* STEP 2 */}
              <div className="features4-grid">

                <div className="feature-images">
                  <span
                    className="fa fa-users"
                    aria-hidden="true"
                  ></span>
                </div>

                <h5>
                  <Link to="/register">
                    Get Your DLMP Code
                  </Link>
                </h5>

                <p>
                  Your registered account is associated with a unique
                  DLMP Code, which can be used when making eligible
                  purchases through participating businesses.
                </p>

              </div>


              {/* STEP 3 */}
              <div className="features4-grid active">

                <div className="feature-images active">
                  <span
                    className="fa fa-shopping-bag"
                    aria-hidden="true"
                  ></span>
                </div>

                <h5>
                  <Link to="/shops">
                    Shop With Participating Businesses
                  </Link>
                </h5>

                <p>
                  Find participating businesses and make eligible purchases
                  through the DLMP21 network. Show your DLMP Code to the
                  participating business where required.
                </p>

              </div>


              {/* STEP 4 */}
              <div className="features4-grid">

                <div className="feature-images">
                  <span
                    className="fa fa-gift"
                    aria-hidden="true"
                  ></span>
                </div>

                <h5>
                  <Link to="/commissions">
                    Track Eligible Rewards
                  </Link>
                </h5>

                <p>
                  Your eligible purchase and network activity may be reflected
                  in your DLMP21 account. Applicable rewards are calculated
                  according to the current DLMP21 program and eligibility rules.
                </p>

              </div>

            </div>

            <div className="middle-button">
              <Link
                to="/how-its-works"
                className="btn button-eff"
              >
                View Full Process
              </Link>
            </div>

          </div>
        </div>
      </section>


      {/* WHY DLMP21 */}
      <section className="w3l-content-11-main">
        <div className="content-design-11">
          <div className="wrapper">

            <h3 className="title-main">
              What DLMP21 Aims To Provide
            </h3>

            <div className="content-sec-11 column content-text">

              <div className="columns">
                <div className="icon-eff">
                  <span
                    className="fa fa-shopping-cart"
                    aria-hidden="true"
                  ></span>
                </div>

                <div className="right-side">
                  <h4>Convenient Local Shopping</h4>

                  <p>
                    Discover participating local businesses and explore
                    products, services and offers available through the
                    DLMP21 platform.
                  </p>
                </div>
              </div>


              <div className="columns">
                <div className="icon-eff">
                  <span
                    className="fa fa-map-marker"
                    aria-hidden="true"
                  ></span>
                </div>

                <div className="right-side">
                  <h4>Connect With Local Businesses</h4>

                  <p>
                    DLMP21 helps customers discover participating businesses
                    based on location and category.
                  </p>
                </div>
              </div>


              <div className="columns">
                <div className="icon-eff">
                  <span
                    className="fa fa-sitemap"
                    aria-hidden="true"
                  ></span>
                </div>

                <div className="right-side">
                  <h4>Structured Customer Network</h4>

                  <p>
                    DLMP21 provides a structured customer network with
                    applicable activity and reward calculations based on the
                    program rules.
                  </p>
                </div>
              </div>


              <div className="columns">
                <div className="icon-eff">
                  <span
                    className="fa fa-line-chart"
                    aria-hidden="true"
                  ></span>
                </div>

                <div className="right-side">
                  <h4>Track Your Activity</h4>

                  <p>
                    Customers can use their DLMP21 account to view available
                    information relating to their purchases, network activity
                    and applicable rewards.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>


      {/* CALL TO ACTION */}
      <section className="w3l-features-4">
        <div className="features4-block">
          <div className="wrapper text-center">

            <h3 className="title-main">
              Join the DLMP21 Network
            </h3>

            <p className="para-cover-9">
              Create your account, discover participating businesses and
              explore the DLMP21 customer reward network.
            </p>

            <div className="middle-button">

              <Link
                to="/register"
                className="btn button-eff mr-2"
              >
                Join as Customer
              </Link>

              <Link
                to="/how-its-works"
                className="btn button-eff"
              >
                Learn More
              </Link>

            </div>

          </div>
        </div>
      </section>


      <Footer />
    </>
  )
}

export default About